import { createSelector } from 'reselect'

export const memoize = (array, handler) => createSelector(array, handler)

export const VALUE_HANDLER = () => value => value

export const VALUE_FUNNEL = value => value

/**
 * Creates a state selector that is memoized
 * in a readable, easy way
 * @param getter getter function for how to retrieve
 *          desired piece of state
 */
export const createStateSelector = (selectIn, getterFn) => withState(memoize(selectIn, getterFn))

export const withState = (value, handler = VALUE_HANDLER) => {
    const selector = createSelector(value, handler())
    return () => selector
}

export const withProps = (value, handler) => () => withState(value, handler)()

/**
 *
 * @param slice namespace of the slice e.g. "video" or "panorama"
 * @param selectorSources an array of either strings or objects
 *                          in the form of { namespace, selectorFn }
 *                          (where selectorFn receives the specific
 *                           slice to operate on)
 * @returns {{}}
 */
export const createSliceSelectors = (slice, selectorSources) => {
    let sliceSelectors = {}
    selectorSources.forEach(source => {
        if (typeof source == 'string') {
            sliceSelectors[source] = createStateSelector(
                /* our string is going to be part of our subslice and just returns that */
                [state => state.getIn([slice, source])],
                /* strings just return the value withing the subslice */
                o => o
            )
        } else if (typeof source == 'object') {
            /* Determine the state selector that we memoize on */
            let selIn =
                //is it defined by the slice instance?
                source.selectorIn
                    ? /**
                       * if it is an array we assume they are referencing other parts of the slice, and note state.get
                       * If that is not the case the state each function recieves will be global state, not subslice
                       */
                      Array.isArray(source.selectorIn)
                        ? //predefined selectors to memoize
                          source.selectorIn
                        : //We want to pass the subslice to selectorIn funciton
                          [state => source.selectorIn(state.getIn([slice]))]
                    : //default memoize on.. is the entire subslice... not good times
                      [state => state.getIn([slice])]

            sliceSelectors[source.namespace] = createStateSelector(
                /* selctors we will memoize on || state of our slize */
                selIn,
                /* we pass the funciton that accepts params or just return the input. */
                source.selectorFn ||
                    function(o) {
                        return o
                    }
            )
        } else {
            throw new Error(
                `createSliceSelectors @ namespace ${source} was ` +
                    `not a valid argument -> ${JSON.stringify(source, null, 2)}`
            )
        }
    })

    // if the root slice wasn't defined, return
    // that by default (e.g. "tour" should contain state->tour)
    if (!sliceSelectors[slice]) {
        sliceSelectors[slice] = createStateSelector([state => state.get(slice)], o => o)
    }

    return sliceSelectors
}
